import type { Cuboid } from './Cuboid';
import type { PointCloudData } from '../value-objects/PointCloudData';

export class Frame {
  constructor(
    readonly frameId: number,
    readonly pointCloud: PointCloudData,
    readonly cuboids: ReadonlyMap<string, Cuboid>,
  ) {}

  getCuboid(uuid: string): Cuboid | null {
    return this.cuboids.get(uuid) ?? null;
  }

  getAllCuboids(): Cuboid[] {
    return Array.from(this.cuboids.values());
  }

  getPointCount(): number {
    return this.pointCloud.count;
  }

  getByteSize(): number {
    const pointsBytes = this.pointCloud.positions.byteLength;
    const cuboidOverhead = this.cuboids.size * 200;
    return pointsBytes + cuboidOverhead;
  }
}
